module.exports = __webpack_public_path__ + "img/logo-full.ea48b7cc.svg";